import { styled } from "@mui/material/styles";
import buildUrl from "build-url-ts";
import React, { useContext, useEffect, useState } from "react";
import { mfdPlotOptions, NamedFaultsOption, namedFaultsOptions } from "../../constants/nameFaultsMfds";
import MultiSelect from "../common/MultiSelect";
import SelectControl from "../common/SelectControl";
import { REPORT_URL } from "../../utils/environmentVariables";
import LocalStorageContext from "../../contexts/LocalStorageContext";

const StyledImage = styled("img")(() => ({
  padding: "5px",
  maxHeight: "80vh",
  width: "25%",
  objectFit: "contain",
  flexGrow: 3,
  flexShrink: 4,
}));

const ControlsContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

const ImageContainer = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  flexWrap: "wrap",
}));

interface NamedFaultsViewProps {
  id: string;
}

const NamedFaultsView: React.FC<NamedFaultsViewProps> = ({ id }: NamedFaultsViewProps) => {
  const {
    namedFaultsView,
    setNamedFaultsView,
    namedFaultsLocations,
    setNamedFaultsLocations,
    mfdPlotSelection,
    setMfdPlotSelection,
  } = useContext(LocalStorageContext);
  const [namedFaultsSelection, setNamedFaultsSelection] = useState<NamedFaultsOption[]>([namedFaultsOptions[0]]);

  const faultOptions: string[] = [];

  namedFaultsOptions.map((option) => {
    faultOptions.push(option.displayName);
  });

  const mfdPlot: string[] = [];

  mfdPlotOptions.map((option) => {
    mfdPlot.push(option.displayName);
  });

  useEffect(() => {
    const filtered = namedFaultsOptions.filter((option) => {
      const result = namedFaultsLocations?.includes(option.displayName);
      return result;
    });
    setNamedFaultsSelection(filtered);
    mfdPlotOptions.map((option) => {
      if (namedFaultsView === option.displayName) {
        setMfdPlotSelection(option);
      }
    });
  }, [namedFaultsView, namedFaultsLocations]);

  const namedFaultsUrl = (id: string, typePath: string, faultPath: string, typeSuffix: string) => {
    return buildUrl(REPORT_URL, {
      path: `${id}/named_fault_mfds/${typePath}/${faultPath}${typeSuffix}`,
    });
  };

  return (
    <>
      <ControlsContainer>
        <MultiSelect
          name="Named Faults"
          selected={namedFaultsLocations}
          options={faultOptions}
          setOptions={setNamedFaultsLocations}
        />
        <SelectControl
          name="Mfd Plot Views"
          options={mfdPlot}
          selection={namedFaultsView}
          setSelection={setNamedFaultsView}
        />
      </ControlsContainer>
      <ImageContainer>
        {namedFaultsSelection?.map((item, i) => (
          <StyledImage
            key={item.path + i}
            src={namedFaultsUrl(id, mfdPlotSelection.typePath as string, item.path, mfdPlotSelection?.path as string)}
          />
        ))}
      </ImageContainer>
    </>
  );
};

export default NamedFaultsView;
